// import classRoomImg from "../../../../assets/img/teacherDashboard/Classroom.png";
import classRoomImg from "../assets/img/teacherDashboard/Classroom.png";
import topBarRightImg from "../assets/img/teacherDashboard/TopBarRightImg.png";

class CDNConfig {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  buildUrl(path) {
    return `${this.baseUrl}/${path}`;
  }
}

const baseUrl = process.env.REACT_APP_CDN_URL;

const config = new CDNConfig(baseUrl);

/**
 * @typedef {Object} ImagesType
 * @property {string} TopImage
 * @property {string} PlayIcon - Play Icon
 * @property {string} SchoolLoginBackground - School Login Background,Forget Password, Reset Password,
 * @property {string} Logo
 *
 */

/**
 * @description
 * This Images is used for all the icons or images used from the cdn
 * @type {ImagesType}
 */
export const Images = {
  // Icons
  TopImage: classRoomImg,
  TopBarRightImg: topBarRightImg,
  Logo: config.buildUrl("static/logo-YQ/YQLogoPlain.png"),
  PlayIcon: config.buildUrl("static/studentadmin/quest/icon/PlayVideo.png"),
  SchoolLoginBackground: config.buildUrl("static/schooladmin/T1.png"),
};
